/**
 * <s-search-launcher> — hands an inline search field over to the global live
 * (predictive) search dialog. When the shopper taps or types in the wrapped
 * input, it opens the dialog via the header's existing search trigger, copies the
 * typed text into the dialog input, and fires an input event so live results load.
 * Without JavaScript the wrapped form still submits to the search page.
 *
 * Attributes: target (dialog id, default "predictive-search"),
 * input-target (dialog input id, default "predictive-search-input").
 */
class SSearchLauncher extends HTMLElement {
  #input = null;
  #opening = false;

  connectedCallback() {
    this.#input = this.querySelector('input[type="search"]');
    if (!this.#input) return;
    this.#input.addEventListener('click', () => this.#open());
    this.#input.addEventListener('input', () => this.#open());
  }

  #open() {
    if (this.#opening) return;
    const dialogId = this.getAttribute('target') || 'predictive-search';
    const dialog = document.getElementById(dialogId);
    const target = document.getElementById(this.getAttribute('input-target') || 'predictive-search-input');
    if (!dialog || !target) return;

    this.#opening = true;
    if (!dialog.open) {
      const trigger = document.querySelector(`[commandfor="${dialogId}"][command="show-modal"]`);
      if (trigger instanceof HTMLElement) {
        trigger.click();
      } else if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    const value = this.#input.value;
    window.requestAnimationFrame(() => {
      target.focus();
      if (value && target.value !== value) {
        target.value = value;
        target.dispatchEvent(new Event('input', { bubbles: true }));
      }
      this.#input.value = '';
      this.#input.blur();
      this.#opening = false;
    });
  }
}

if (!customElements.get('s-search-launcher')) {
  customElements.define('s-search-launcher', SSearchLauncher);
}
